export default __webpack_public_path__ + "static/media/softball-player-image.b5eb2cc0.png";